// @flow
import {
  type Http,
} from '@ux/drivers';
import * as r from 'ramda';

export type MiddlewareDriver = (
  options: {
    method: string,
    data: Object,
  },
) => Promise<any>;

export const createMiddlewareDriver = (
  environment: Object,
) => (
  http: Http,
): MiddlewareDriver => r.pipe(
  r.assoc('url', r.prop('middlewareApiUrl', environment)),
  http,
  r.invoker(1, 'catch')((err) => {
    console.error(err); // eslint-disable-line
    throw err;
  }),
);

export default createMiddlewareDriver;
